import {
  ADD_POLL,
  ADD_POLL_SUCCESS,
  ADD_POLL_FAILED,
  GET_POLL,
  GET_POLL_SUCCESS,
  GET_POLL_FAILED,
  RESET_POLL,
  UPDATE_POLL,
  UPDATE_POLL_SUCCESS,
  UPDATE_POLL_FAILED,
  GET_POLL_LIST,
  GET_POLL_LIST_SUCCESS,
  GET_POLL_LIST_FAILED,
  OPEN_DELETE_POLL_MODAL,
  HIDE_DELETE_POLL_MODAL,
  DELETE_POLL,
  DELETE_POLL_SUCCESS,
  DELETE_POLL_FAILED,
  UPDATE_POLL_LIST_ITEM,
  UPDATE_POLL_LIST_ITEM_SUCCESS,
  UPDATE_POLL_LIST_ITEM_FAILED,
  UPDATE_POLL_ORDER,
  UPDATE_POLL_ORDER_SUCCESS,
  UPDATE_POLL_ORDER_FAILED,
  GET_POLL_REPLY,
  GET_POLL_REPLY_SUCCESS,
  GET_POLL_REPLY_FAILED,
  RESET_POLL_REPLY,
  RESET_POLL_LIST,
} from "./actionTypes"

export const addPoll = (questions, poll) => ({
  type: ADD_POLL,
  payload: { questions, poll },
})

export const addPollSuccess = response => ({
  type: ADD_POLL_SUCCESS,
  payload: response,
})

export const addPollFailed = error => ({
  type: ADD_POLL_FAILED,
  payload: error,
})

export const getPoll = params => ({
  type: GET_POLL,
  payload: params,
})

export const getPollSuccess = response => ({
  type: GET_POLL_SUCCESS,
  payload: response,
})

export const getPollFailed = error => ({
  type: GET_POLL_FAILED,
  payload: error,
})

export const resetPoll = () => ({
  type: RESET_POLL,
  payload: {},
})

export const updatePoll = (questions, poll) => ({
  type: UPDATE_POLL,
  payload: { questions, poll },
})

export const updatePollSuccess = response => ({
  type: UPDATE_POLL_SUCCESS,
  payload: response,
})

export const updatePollFailed = error => ({
  type: UPDATE_POLL_FAILED,
  payload: error,
})

export const getPollList = params => ({
  type: GET_POLL_LIST,
  payload: params,
})

export const getPollListSuccess = response => ({
  type: GET_POLL_LIST_SUCCESS,
  payload: response,
})

export const getPollListFailed = error => ({
  type: GET_POLL_LIST_FAILED,
  payload: error,
})

export const resetPollList = () => ({
  type: RESET_POLL_LIST,
  payload: {},
})

export const openDeletePollModal = () => ({
  type: OPEN_DELETE_POLL_MODAL,
  payload: {},
})

export const hideDeletePollModal = () => ({
  type: HIDE_DELETE_POLL_MODAL,
  payload: {},
})

export const deletePoll = params => ({
  type: DELETE_POLL,
  payload: params,
})

export const deletePollSuccess = response => ({
  type: DELETE_POLL_SUCCESS,
  payload: response,
})

export const deletePollFailed = error => ({
  type: DELETE_POLL_FAILED,
  payload: error,
})

export const updatePollListItem = params => ({
  type: UPDATE_POLL_LIST_ITEM,
  payload: params,
})

export const updatePollListItemSuccess = response => ({
  type: UPDATE_POLL_LIST_ITEM_SUCCESS,
  payload: response,
})

export const updatePollListItemFailed = error => ({
  type: UPDATE_POLL_LIST_ITEM_FAILED,
  payload: error,
})

export const updatePollOrder = params => ({
  type: UPDATE_POLL_ORDER,
  payload: params,
})

export const updatePollOrderSuccess = response => ({
  type: UPDATE_POLL_ORDER_SUCCESS,
  payload: response,
})

export const updatePollOrderFailed = error => ({
  type: UPDATE_POLL_ORDER_FAILED,
  payload: error,
})

export const getPollReply = params => ({
  type: GET_POLL_REPLY,
  payload: params,
})

export const getPollReplySuccess = response => ({
  type: GET_POLL_REPLY_SUCCESS,
  payload: response,
})

export const getPollReplyFailed = error => ({
  type: GET_POLL_REPLY_FAILED,
  payload: error,
})

export const resetPollReply = () => ({
  type: RESET_POLL_REPLY,
  payload: {},
})
